import { Button } from "components/DesignSystem/Button/Button";
import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import { MAILROOM } from "constants/addons";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import {
  LockDescription,
  LockFeatures,
} from "pages/Books/RevenueMetrics/RevenueMetricsLocked";
import { useDispatch } from "react-redux";
import { useGetSubscriptionsQuery } from "store/apis/subscriptions";
import { setAddonData, setAddonType } from "store/slices/addons";
import MailRoomIndex from "static/images/BannerMailRoomIndex.png";

const Description = () => (
  <div className="t-flex t-flex-col t-gap-2">
    <div className="t-text-body-sm t-text-text-30">
      Get a digital mail address for your business
    </div>
    <div className="t-text-body-sm-italic t-italic t-text-blue-70">
      We only service in Delaware as of now
    </div>
  </div>
);

export const LockedMailroomComponent = () => {
  const { uuid: groupId } = useCurrentGroupContext();
  const entityId = useCurrentEntityId();
  const { data: allSubscriptions = [] } = useGetSubscriptionsQuery(
    {
      groupId,
      entityId,
    },
    { skip: !entityId || !groupId }
  );

  const dispatch = useDispatch();

  const mailroomSubscriptionData = allSubscriptions?.find(
    (subscription) => subscription.subscription_type === "MAILROOM"
  );

  const { amount, stripe_coupon } = mailroomSubscriptionData || {};
  const updatedAmount = stripe_coupon?.discounted_amount.toString() || amount;

  const updatedMailroomSubscription = {
    ...mailroomSubscriptionData,
    amount: Number(updatedAmount),
  };

  const openMailroomAddon = () => {
    dispatch(setAddonData(updatedMailroomSubscription));
    dispatch(setAddonType(MAILROOM));
  };

  const featureDetails = [
    {
      type: "usaPin",
      description: "Premium US address for your business",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "timeTwentyFour",
      description: "24/7 instant access to your mail",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "newsLetter",
      description: "Scan, forward or shred your mail all online",
    },
  ];

  return (
    <section className="t-flex t-justify-center t-h-full t-w-full t-items-center">
      <FeatureDetails
        banner={
          <img
            className="t-w-[22.5625rem] t-h-[13.5rem] t-object-cover"
            src={MailRoomIndex}
            alt="MailRoomBanner"
          />
        }
        description={
          <LockDescription
            descriptionText={<Description />}
            title="Inbox (Mailroom)"
          />
        }
        feature={
          <div className="t-flex t-gap-5 t-w-[31.8125rem] sm:t-w-full sm:t-flex-col sm:t-gap-4 sm:t-max-h-none t-mx-auto t-items-center">
            {featureDetails.map((feature, index) => (
              <LockFeatures
                key={index}
                type={feature.type}
                description={feature.description}
              />
            ))}
          </div>
        }
        button={
          <Button
            onClick={openMailroomAddon}
            customType="primary"
            size="regular"
          >
            Get Started
          </Button>
        }
      />
    </section>
  );
};
